<template>
  <header
    class="content h-[100px] flex items-center justify-between relative z-[100]"
  >
    <img src="../assets/images/logo.svg" alt="logo" class="logo" />

    <Transition :duration="550" name="nested">
      <ul class="outer flex items-center gap-[30px] text-sm" v-if="hamburger">
        <li
          v-for="(li, index) in lis"
          :key="index"
          class="inner cursor-pointer hover:opacity-50 transition duration-300"
        >
          {{ li }}
        </li>
      </ul>
    </Transition>

    <button class="btn-style">Get Started</button>

    <button class="hamburger" @click="hamburger = !hamburger">
      <img v-if="hamburger" src="../assets/images/icon-close.svg" alt="close" />
      <img v-else src="../assets/images/icon-hamburger.svg" alt="hamburger" />
    </button>
  </header>
  <div class="overlay" v-if="hamburger"></div>
</template>

<script>
export default {
  data() {
    return {
      hamburger: false,
      lis: ["Pricing", "Product", "About Us", "Careers", "Community"],
    };
  },

  watch: {
    hamburger(newVal) {
      if (newVal) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "auto";
      }
    },
  },
};
</script>

<style lang="scss">
header {
  ul {
    @media (max-width: 768px) {
      padding: 20px;
      position: absolute;
      top: 110px;
      width: 100%;
      flex-direction: column;
      background-color: white;
      box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
      border-radius: 10px;
      font-weight: 600;
    }
  }

  button.btn-style {
    @media (max-width: 768px) {
      display: none;
    }
  }

  button.hamburger {
    @media (min-width: 769px) {
      display: none;
    }
  }
}

.overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.5), transparent);
  z-index: 50;
}

.nested-enter-active,
.nested-leave-active {
  transition: all 0.3s ease-in-out;
}
.nested-leave-active {
  transition-delay: 0.25s;
}

.nested-enter-from,
.nested-leave-to {
  transform: translateY(30px);
  opacity: 0;
}

.nested-enter-active .inner,
.nested-leave-active .inner {
  transition: all 0.3s ease-in-out;
}
.nested-enter-active .inner {
  transition-delay: 0.25s;
}

.nested-enter-from .inner,
.nested-leave-to .inner {
  transform: translateX(30px);
  opacity: 0.001;
}
</style>
